import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';

import router from './plugins/router';
import { options, quasar } from './plugins/quasar';
import { i18n } from './plugins/i18n';
import VueCookies from 'vue-cookies';
// Import icon libraries
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import { register } from 'swiper/element/bundle';
register();

createApp(App)
  .use(router)
  .use(createPinia())
  .use(i18n)
  .use(quasar, options)
  .use(VueCookies, { expires: '1m' })
  .mount('#app');
